import '.b6{position:relative;}.ssr-plugin'
import '.im{width:64px;}.ssr-plugin'
import '.in{height:64px;}.ssr-plugin'
import '.as{flex-shrink:0;}.ssr-plugin'
import '.b9{position:absolute;}.ssr-plugin'
import '.io{bottom:-4px;}.ssr-plugin'
import '.fp{right:-4px;}.ssr-plugin'
import '.et{border-radius:50%;}.ssr-plugin'
import '.ip{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ah{overflow:hidden;}.ssr-plugin'
import '.iq{width:32px;}.ssr-plugin'
import '.ir{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="b6 im in as"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b9 io fp et ip ah iq ir"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
